import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=47eeb1fc&scoped=true&"
import script from "./Areas.vue?vue&type=script&lang=js&"
export * from "./Areas.vue?vue&type=script&lang=js&"
import style0 from "./Areas.vue?vue&type=style&index=0&id=47eeb1fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eeb1fc",
  null
  
)

export default component.exports